<script lang="ts">
  import Icon from "@shared/svelte/Components/Icon.svelte";
  const specs = window["C"].IMAGE_PATHS["specs_color_logo.svg"];

  export let onSignupClicked: () => void;

</script>

<div class="fizz-layout-one-col-centered" data-testid="landing-page">
  <div class="fizz-center-content fizz-stack-32">
    <div class="fizz-flex-row">
      <Icon type="ProviHeroBlue" height="86" width="86" />
      <div class="fizz-heading-1 fizz-inline-0">+</div>
      <img alt="specs" src={specs} height="86" width="86" />
    </div>
  </div>
  <div class="fizz-heading-1 fizz-stack-16">Welcome to Provi!</div>
  <div class="fizz-stack-32">
    Spec's Wine, Spirits & Finer Foods has teamed up with Provi to bring you a best-in-class online
    ordering experience!
  </div>
  <div class="fizz-flex-row">
    <Icon type="Tick" height="16" width="16" />
    <div class="fizz-heading-4">Hit the ground running</div>
  </div>
  <div class="fizz-inset-horizontal-32 fizz-stack-16">
    We'll make a list of items you've purchased on Spec's to make reordering a breeze.
  </div>
  <div class="fizz-flex-row">
    <Icon type="Tick" height="16" width="16" />
    <div class="fizz-heading-4">Get your orders when you need them</div>
  </div>
  <div class="fizz-inset-horizontal-32 fizz-stack-16">
    Choose your date for delivery, or order for in-store pick up. We've got you covered.
  </div>
  <div class="fizz-flex-row">
    <Icon type="Tick" height="16" width="16" />
    <div class="fizz-heading-4">Save countless hours</div>
  </div>
  <div class="fizz-inset-horizontal-32 fizz-stack-32">
    Manage your beverage program in half the time! Place all of your orders in one click.
  </div>
  <button
    class="fizz-button-secondary fizz-button fizz-stack-16 fizz-full-width"
    data-testid="sign-up-button"
    on:click={onSignupClicked}>Sign up</button
  >
  <div class="fizz-center-content fizz-text-small fizz-text-subdued fizz-stack-24">
    When continuing on Provi, you will lose access to the online ordering feature via Spec's Online
    prior to the January 9th transition.
  </div>
  <div class="fizz-center-content">
    Already signed up and connected your Spec's account? <a
      class="fizz-text-strong"
      href={"/users/sign_in"}
      on:click={() => (window.location.href = "/users/sign_in")}
      data-testid="log-in">Log in</a
    >
  </div>
</div>
